var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import * as _ from "lodash";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
const fake_expAnalysisApi = {
  fakeStudies: [
    {
      content: {
        Id: ""
      }
    }
  ],
  fakeStudyAbstracts: {}
};
const fake_forayConfigMetadata = null;
const fake_analysisStepProperties = null;
let AnalysisResources = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api");
    __publicField(this, "_fakeStudies", null);
  }
  getV2StudyAbstractsForStepId(stepId) {
    return __async(this, null, function* () {
      const address = `/analysis/steps/${stepId}/studyAbstracts?includeTasks=true&json`;
      const result = yield this._get(address);
      return result;
    });
  }
  getV2StudyAbstract(stepId, studyId) {
    return __async(this, null, function* () {
      const address = `/analysis/steps/${stepId}/studyAbstracts/${studyId}?includeTasks=true&json`;
      const result = yield this._get(address);
      return result;
    });
  }
  getV2TaskLogsForTaskId(taskId) {
    return __async(this, null, function* () {
      const address = `/analysis/tasks/${taskId}/logs?includePipelineJournalLogs=true&json`;
      const result = yield this._get(address);
      return result;
    });
  }
  getForayConfigMetadata() {
    return __async(this, null, function* () {
      const address = `/analysis/internal/forayConfigMetadata`;
      const result = yield this._get(address);
      return result;
    });
  }
  registerAnalysis(stepId) {
    return __async(this, null, function* () {
      const address = `/analysis/register?expStepId=${stepId}`;
      const result = yield this._post({}, address);
      return result;
    });
  }
  getTaskOverviewInfoForScorecardId(scorecardId) {
    return __async(this, null, function* () {
      const address = `/analysis/scorecards/taskOverviewInfo?scorecardIds=${scorecardId}`;
      const result = yield this._get(address);
      return result;
    });
  }
  getExperimentStepPlanSummary(stepId) {
    return __async(this, null, function* () {
      const address = `/experiments/steps/${stepId}/planSummary`;
      const result = yield this._get(address);
      return result;
    });
  }
  getAnalysisStepProperties(stepId) {
    return __async(this, null, function* () {
      const address = `/analysis/internal/stepProperties?experimentStepId=${stepId}`;
      const result = yield this._get(address);
      return result;
    });
  }
  getStudy(id) {
    return __async(this, null, function* () {
      const address = `/analysis/studies/${id}`;
      const result = yield this._get(address);
      return result;
    });
  }
  setStudyActiveState(studyId, isActive) {
    return __async(this, null, function* () {
      const address = `/analysis/setActiveState?studyId=${studyId}&isActive=${isActive}`;
      const dataNotNeeded = {};
      const result = yield this._put(dataNotNeeded, address);
      return result;
    });
  }
  deleteStudy(studyId) {
    return __async(this, null, function* () {
      const address = `/analysis/delete?studyId=${studyId}`;
      const postBody = "deleted study from exp-ux";
      const result = yield this._post(postBody, address);
      return result;
    });
  }
  getAnalysisRequestForm(stepId, isVNextExpMan) {
    return __async(this, null, function* () {
      const address = `/analysis/internal/analysisRequestForm?experimentStepId=${stepId}&isVNextExpMan=${isVNextExpMan}`;
      const result = yield this._get(address);
      return result;
    });
  }
  createAnalysisStudy(request) {
    return __async(this, null, function* () {
      const address = `/analysis/create`;
      const result = yield this._post(request, address);
      return result;
    });
  }
  readTemplate(templateName) {
    return __async(this, null, function* () {
      const result = yield this._get(`/analysis/templates/${templateName}`);
      return result;
    });
  }
  resubmitAnalysisTasks(request) {
    return __async(this, null, function* () {
      const address = `/analysis/tasks/resubmit`;
      const result = yield this._patch(request, address);
      result.ensureSuccess();
    });
  }
  cancelAnalysisTasks(request) {
    return __async(this, null, function* () {
      const address = `/analysis/tasks/cancel`;
      const result = yield this._patch(request, address);
      result.ensureSuccess();
    });
  }
  getSegmentsDataFromAPI(metricSetId, metricSetVersion) {
    return __async(this, null, function* () {
      const result = yield this._get(`/analysis/metricSets/${metricSetId}/segments?version=${metricSetVersion}`);
      return result;
    });
  }
  uploadSupportFiles(fileInfos) {
    return __async(this, null, function* () {
      let formData = new FormData();
      _.each(fileInfos, (f) => formData.append(f.name, f.data));
      const result = yield this._postFormData(`/analysis/supportfiles`, formData);
      return result;
    });
  }
  getSampleForayJobConfig(request) {
    return __async(this, null, function* () {
      const result = yield this._post(request, `/analysis/sampleForayJobConfig`);
      return result;
    });
  }
  updateAnalysisStudy(request) {
    return __async(this, null, function* () {
      const result = yield this._put(request, `/analysis/update`);
      return result;
    });
  }
};
__decorateClass([
  onError({ message: `An error occured while getting Study Abstracts (V2)` })
], AnalysisResources.prototype, "getV2StudyAbstractsForStepId", 1);
__decorateClass([
  onError({ message: `An error occured while getting Study Abstract (V2)` })
], AnalysisResources.prototype, "getV2StudyAbstract", 1);
__decorateClass([
  onError({ message: `An error occured while getting Task Logs (V2)` })
], AnalysisResources.prototype, "getV2TaskLogsForTaskId", 1);
__decorateClass([
  onError({ message: `An error occured while getting ForayConfigMetadata.` })
], AnalysisResources.prototype, "getForayConfigMetadata", 1);
__decorateClass([
  onError({ message: `An error occured while registering analysis` })
], AnalysisResources.prototype, "registerAnalysis", 1);
__decorateClass([
  onError({ message: `An error occured while getting getTaskOverviewInfoForScorecardId.` })
], AnalysisResources.prototype, "getTaskOverviewInfoForScorecardId", 1);
__decorateClass([
  onError({ message: `An error occured while getting AnalysisStepProperties.` })
], AnalysisResources.prototype, "getExperimentStepPlanSummary", 1);
__decorateClass([
  onError({ message: `An error occured while getting AnalysisStepProperties.` })
], AnalysisResources.prototype, "getAnalysisStepProperties", 1);
__decorateClass([
  onError({ message: `An error occured while getting Study` })
], AnalysisResources.prototype, "getStudy", 1);
__decorateClass([
  onError({ message: `An error occured while setting study setActiveState (enable/disable)` })
], AnalysisResources.prototype, "setStudyActiveState", 1);
__decorateClass([
  onError({ message: `An error occured while deleting study` })
], AnalysisResources.prototype, "deleteStudy", 1);
__decorateClass([
  onError({ message: `An error occured while fetching Analysis request form` })
], AnalysisResources.prototype, "getAnalysisRequestForm", 1);
__decorateClass([
  onError({ message: `An error occured while creating Analysis study` })
], AnalysisResources.prototype, "createAnalysisStudy", 1);
__decorateClass([
  onError({ message: `An error occurred retrieving the template.` })
], AnalysisResources.prototype, "readTemplate", 1);
__decorateClass([
  onError({ message: `An error occured while resubmitting the Analysis task` })
], AnalysisResources.prototype, "resubmitAnalysisTasks", 1);
__decorateClass([
  onError({ message: `An error occured while cancelling the Analysis task` })
], AnalysisResources.prototype, "cancelAnalysisTasks", 1);
__decorateClass([
  onError({ message: `An error occurred retrieving the segment data` })
], AnalysisResources.prototype, "getSegmentsDataFromAPI", 1);
__decorateClass([
  onError({ message: `An error occurred while uploading files` })
], AnalysisResources.prototype, "uploadSupportFiles", 1);
__decorateClass([
  onError({ message: `An error occurred while getting Sample foray job config` })
], AnalysisResources.prototype, "getSampleForayJobConfig", 1);
__decorateClass([
  onError({ message: `An error occurred while editing analysis request` })
], AnalysisResources.prototype, "updateAnalysisStudy", 1);
AnalysisResources = __decorateClass([
  WPSProxyConverter()
], AnalysisResources);
const AnalysisResources$1 = new AnalysisResources();
export {
  AnalysisResources,
  AnalysisResources$1 as default
};
//# sourceMappingURL=AnalysisResources.js.map
